<template>
	<c-dialog ref="dialog" title="统计报告详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
		<module>
			<module-col size="320">
				<c-detail class="m-detail-form">
					<c-detail-item label="场次">
						{{master.auction_batch_no || '-'}}
					</c-detail-item>
					<c-detail-item label="总台数">
						{{master.total_cnt == null ? '-' : master.total_cnt}}
					</c-detail-item>
					<c-detail-item label="成交台数">
						{{master.deal_cnt == null ? '-' : master.deal_cnt}}
					</c-detail-item>
					<c-detail-item label="成交总额">
						{{formatPrice(master.deal_amount)}}
					</c-detail-item>
					<c-detail-item label="毛利">
						{{formatPrice(master.gross_profit)}}
					</c-detail-item>
					<c-detail-item label="毛利率">
						{{formatRate(master.gross_profit_rate)}}
					</c-detail-item>
					<c-detail-item label="平均毛利">
						{{formatPrice(master.avg_gross_profit)}}
					</c-detail-item>
					<c-detail-item label="报告生成时间">
						{{master.report_gen_time || '-'}}
					</c-detail-item>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="渠道汇总" enable-flex>
					<div class="m-detail-box">
						<c-table :data="summaryList" border :paging="false">
							<c-table-column label="销售渠道" min-width="160">
								<template #default="{data}">{{data.channel_name || '-'}}</template>
							</c-table-column>
							<c-table-column label="成交台数" width="100">
								<template #default="{data}">{{data.deal_cnt}}</template>
							</c-table-column>
							<c-table-column label="成交额" width="120">
								<template #default="{data}">{{formatPrice(data.deal_amount)}}</template>
							</c-table-column>
							<c-table-column label="毛利" width="120">
								<template #default="{data}">{{formatPrice(data.gross_profit)}}</template>
							</c-table-column>
							<c-table-column label="毛利率" width="100">
								<template #default="{data}">{{formatRate(data.gross_profit_rate)}}</template>
							</c-table-column>
						</c-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'auctionStatReportDetail',

		data() {
			return {
				reportId: '',
				master: {},
				summaryList: []
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.reportId = data.id;
				this.master = {};
				this.summaryList = [];
				this.$refs.dialog.open();
				this.loadDetail();
			},

			/*********加载报告详情**********/
			loadDetail() {
				this.request({
					url: '/sale/auction/report/stat/detail',
					data: {
						id: this.reportId
					},
					loading: true,
					success: data => {
						this.master = data || {};
						this.summaryList = this.parseSummary(this.master.channel_summary_json);
					}
				});
			},

			/*********解析渠道汇总JSON**********/
			parseSummary(json) {
				try {
					var list = JSON.parse(json || '[]');
					return Array.isArray(list) ? list : [];
				} catch (e) {
					return [];
				}
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********格式化百分比**********/
			formatRate(rate) {
				if (rate === null || rate === undefined || rate === '') return '-';
				return parseFloat(rate).toFixed(2) + '%';
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-box {
		padding: 10px;
	}
</style>
